import { Image } from 'react-datocms';

import Video from './video';

interface Props {
  media: any;
  fill?: boolean;
  imageOptions?: {
    [key: string]: any;
  };
  videoOptions?: {
    autoplay?: boolean;
    controls?: boolean;
    loop?: boolean;
    muted?: boolean;
    playsinline?: boolean;
  };
}

export default function Media({
  media,
  fill = false,
  videoOptions = {
    autoplay: true,
    controls: false,
    loop: false,
    muted: true,
    playsinline: true,
  },
}: Props) {
  if (media?.responsiveImage) {
    return (
      // eslint-disable-next-line jsx-a11y/alt-text
      <Image
        data={media?.responsiveImage}
        objectFit="cover"
        usePlaceholder={false}
        fadeInDuration={100}
        layout={fill ? 'fill' : 'responsive'}
      />
    );
  }

  if (media?.video) {
    return <Video video={media.video} videoOptions={videoOptions} fill={fill} />;
  }

  return null;
}
